"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tooltip = void 0;
const react_1 = __importDefault(require("react"));
const foundations_1 = require("../../foundations");
const TextV2_1 = require("../../foundations/Typography/TextV2");
const useTooltipVisibility_1 = require("../../hooks/useTooltipVisibility");
const TooltipStyles_1 = require("./TooltipStyles");
const contentStyles = {
    position: "relative",
    backgroundColor: "surface-neutral-default",
    borderRadius: "radius-2",
    paddingY: "spacing-2",
    paddingX: "spacing-3",
    lineHeight: "leading-2"
};
const Tooltip = ({ children, content, arrowPosition }) => {
    const { visible, showTooltip, hideTooltip } = (0, useTooltipVisibility_1.useTooltipVisibility)();
    const tooltipId = react_1.default.useId();
    const tooltipStyles = react_1.default.useMemo(() => (0, TooltipStyles_1.getTooltipStyles)(arrowPosition), [arrowPosition]);
    return (react_1.default.createElement(foundations_1.Box, { tabIndex: 0, onMouseEnter: showTooltip, onMouseLeave: hideTooltip, onFocus: showTooltip, onBlur: hideTooltip, onTouchStart: showTooltip, onTouchEnd: hideTooltip, sx: { position: "relative" } },
        react_1.default.createElement(foundations_1.Box, { "aria-describedby": visible ? tooltipId : undefined }, children),
        visible && (react_1.default.createElement(foundations_1.Box, { id: tooltipId, role: "tooltip", "aria-hidden": !visible, sx: tooltipStyles },
            react_1.default.createElement(foundations_1.Box, { sx: contentStyles },
                react_1.default.createElement(TextV2_1.TextV2, { variant: "body-2-regular" }, content))))));
};
exports.Tooltip = Tooltip;
//# sourceMappingURL=Tooltip.js.map